const Header = () => (
  <div className=''>
    <div className=' text-center  max-md:text-left'>
      <div className='max-w-160 mx-auto mb-4 text-h3 max-lg:max-w-120 max-lg:text-h4'>
        Services
      </div>
      <div className='max-w-142 mx-auto mb-4 text-[1.125rem] font-medium tracking-[-0.01em] text-t-secondary'>
        Discover our next-gen crypto services built for speed, simplicity, and
        total control.
      </div>
    </div>
  </div>
);

export default Header;
